/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
/** @jsx jsx */

import React, { useEffect, useCallback } from 'react';
import FormContents from 'components/atoms/Form/FormContents';
import FlexBox from 'components/atoms/FlexBox';
import { css, jsx } from '@emotion/core';
import Checkbox from 'components/molecules/Checkbox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import useOrgTreesOptions from 'hooks/useOrgTreesOptions';
import moment from 'moment';
import useToastNotification from 'hooks/useToastNotification';
import BlockUI from 'components/molecules/BlockUi';
import FormLabel from 'components/atoms/Form/FormLabel';
import useAchievementErrorState from '../hook';
import ContextMenu from 'components/molecules/ContextMenu';
import getContextMenuButtons from 'components/molecules/ContextMenu/getContextMenuButtons';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-grid-system';
import BodyText from 'components/atoms/BodyText';
import Radio from 'components/molecules/Radio';
import FormPadding from 'components/atoms/Form/FormPadding';
import DataTable from 'components/organismos/DataTable/DataTable';
import CalendarForm from 'components/molecules/CalendarForm';
import IconLabelButton from 'components/molecules/IconLabelButton';
import { downloadErrorCSV, downloadAlertCSV, downloadErrorCSVV2 } from "api/attendError";
import IconTooltip from 'components/molecules/IconTooltip';
import { utilityColor } from 'components/styles';
import {downloadCSV} from 'api/attendError';
import { isTablet, isSafari } from "react-device-detect";
import FormHeader from 'components/templates/FormHeader';
import SelectForm from 'components/molecules/SelectForm';
import CalendarRangeV2 from 'components/molecules/CalendarV1/CalendarRangeV2';

const isIpad = window.matchMedia("(max-width: 1024px)").matches;

const styles = {
  table: css`
    table th:nth-of-type(1) {
      width: 70px;
    }
    table th:nth-of-type(2) {
      width: 52px;
    }
    table th:nth-of-type(3) {
      width: 62px;
    }
    table td:nth-of-type(3) {
      text-align: center;
    }
    table th:nth-of-type(4) {
      width: 80px;
    }
    table th:nth-of-type(5) {
      width: 100px;
    }
    table th:nth-of-type(6) {
      width: 85px;
    }
    table td:nth-of-type(6) {
      text-align: center;
    }
    table th:nth-of-type(7) {
      width: 70px;
    }
    table th:nth-of-type(8) {
      width: 50px;
    }
    table th:nth-of-type(9) {
      width: 50px;
    }
    table td:nth-of-type(10),
    table th:nth-of-type(10) {
      width: 100px;
      text-align: center;
    }
    table td:nth-of-type(11),
    table th:nth-of-type(11) {
      width: 42px;
      white-space: pre-line;
    }
    table th:nth-of-type(11) span {
      display:block;
      margin: auto;
    }
    table th:nth-of-type(11) span svg {
      margin-left: 0!important;
    }
    table td:nth-of-type(11) {
      text-align: center;
    }
    table th:nth-of-type(12) {
      width: 50px;
    }
    table td:last-child {
      text-align: center;
    }
    .svg-red path:last-child {
      fill: red;
    }
    .svg-yellow path:last-child {
      fill: #f2c94c;
    }
  `,
  flexBox: css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }),
  customStyle: css(
    {
      display: "flex",
      marginLeft: "0",
      justifyContent:
        (isSafari && isTablet) || isIpad ? "flex-start" : "flex-end",
         paddingRight: (isSafari && isTablet) || isIpad ? "10px" : "30px",
         marginBottom: (isSafari && isTablet) || isIpad ? "0px" : "-40px"
    },
    css`
      button {
        width: auto;
        margin-left: 12px;
      }
      button:hover {
        background: transparent;
      }
      button svg {
        width: 20px !important;
        height: 20px !important;
      }`
  ),
  radio: {
    paddingRight: `${isIpad ? '0%' : '5%'}`
  },
  checkbox: {
    paddingRight: `${isIpad ? '0%' : '15%'}`
  }
};

const AttendanceError: React.FC = () => {
  const history = useHistory();
  const { errorNotification } = useToastNotification();
  const refixTable = 'attendError';

  const {
    targetDateFrom,
    setTargetDateFrom,
    targetDateTo,
    setTargetDateTo,
    orgCode,
    setOrgCode,
    isFilter,
    setIsFilter,
    errorList,
    isLoading,
    setIsLoading,
    fetchData,
    isOT,
    setOT,
    isHolidayWork,
    setHolidayWork,
    isBreak,
    setBreak,
    isWorkingTogether,
    setWorkingTogether,
    isUnder18,
    setUnder18,
    isForeigner,
    setForeigner,
    staffsForOrgCodeOptions,
    staffCode,
    setStaffCode,
    site
  } = useAchievementErrorState();

  const storeOptions = useOrgTreesOptions(moment(targetDateFrom).format('YYYY-MM-DD'), moment(targetDateTo).format('YYYY-MM-DD'), ['3', '2'].indexOf(sessionStorage.getItem('loginUser.site') || "") !== -1);

  const downloadFileCSV = useCallback(() => {
    const companyCode = sessionStorage.getItem("loginUser.companyCode") || "";
    downloadCSV(companyCode);
  }, []);

  const downloadFileErrorCSV = async () => { 
    const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
    const targetDateFrom = sessionStorage.getItem('attendError.targetDateFrom') || '';
    const targetDateTo = sessionStorage.getItem('attendError.targetDateTo') || '';
    const searchType = 0;
    setIsLoading(true);
    await downloadErrorCSVV2(
      staffCode,
      companyCode,
      orgCode,
      targetDateFrom,
      targetDateTo,
      searchType
    ).then((response : any) => {
      setIsLoading(false);
    }); 
  };

  const downloadFileAlertCSV = async () => {
    const companyCode = sessionStorage.getItem('loginUser.companyCode') || ''; 
    const targetDateFrom = sessionStorage.getItem('attendError.targetDateFrom') || '';
    const targetDateTo = sessionStorage.getItem('attendError.targetDateTo') || '';
    const searchType = 1;
    setIsLoading(true);
    await downloadAlertCSV(
      staffCode,
      companyCode,
      orgCode,
      targetDateFrom,
      targetDateTo,
      searchType,
      isOT,
      isHolidayWork,
      isBreak,
      isWorkingTogether,
      isUnder18,
      isForeigner
    ).then((response : any) => {
      setIsLoading(false);
    });
  }; 

  function getStampTimeStyle(haveError: any, haveAlert: any, applicationStatus: any, haveContent: any) {
    if (!haveContent) {
      return {};
    }

    if (haveError === true) {  // エラー
      return { backgroundColor: '#fdefef' };
      // return { backgroundColor: '#fdefef' };
    }

    if (applicationStatus == "0") {  // 申請中
      // return { backgroundColor: 'rgb(60,189,172)' };
      // return "border:5px solid rgb(60,189,172)";
      return { backgroundColor: '#e6fff7' };
    } else if (applicationStatus == "1") {   // 承認
      return { backgroundColor: '#f2f8fc' };
      // return "border:5px solid rgb(60,77,189)";
    }

    if (haveAlert === true) {  // アラート
      return { backgroundColor: 'rgb(189,172,60)' };
      // return "border:5px solid rgb(189,172,60)";
    }

    return {};
  }

  useEffect(() => {
    if (moment(targetDateTo).diff(targetDateFrom, 'year') >= 1) {
      errorNotification('対象期間の範囲は１年以内で入力してください');
      return;
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staffCode, 
      orgCode, 
      targetDateFrom, 
      targetDateTo, 
      isFilter, 
      isOT, 
      isHolidayWork, 
      isBreak, 
      isWorkingTogether, 
      isUnder18, 
      isForeigner]
  );

  const columns = React.useMemo(
    () => [
      {
        Header: '種別',
        accessor: 'hasError',
        Cell: (cell: { row: { isExpanded: boolean, original: any } }) => {
          return (
            <div
              style={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex'
              }}
            >
              <span style={{ marginTop: '-3px' }}>
                {cell.row.original.hasError === '1' ? 'エラー' : 'アラート'}
              </span>
                <div>
                  <IconTooltip 
                    iconType='warning'
                    text={cell.row.original.errorMessage || ''}
                    color={cell.row.original.hasError === '1' ? utilityColor.error : utilityColor.yellow}
                  />
                </div>                    
            </div>
          )
        },
      },
      {
        Header: '修正',
        accessor: 'history',
        disableSortBy: true,
        Cell: (cell: { row: { isExpanded: boolean, original: any, index: number } }) => (
          <div>
            {
              (cell.row.original.stampApplicationStatus !== 0) && (
                <ContextMenu
                  text="申請"
                  buttons={
                    getContextMenuButtons(
                      history,
                      cell.row.original.modifierApplicationId,
                      cell.row.original.orgCode,
                      cell.row.original.staffCode,
                      cell.row.original.staffName,
                      null,
                      cell.row.original.holidayApplicationStatus,
                      cell.row.original.overtimeApplicationStatus,
                      cell.row.original.holidayworkApplicationStatus,
                      null,
                      "",
                      cell.row.original.useOverTimeApplication,
                      cell.row.original.necessaryHolidayWorkApplication,
                      cell.row.original.useTransferApplication,
                      cell.row.original.achievementId,
                      cell.row.original.targetDate,
                      cell.row.original.stampVersion,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      cell.row.original.stampApplicationStatus,
                      cell.row.original.hasError,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      cell.row.index
                    )
                  }
                />
              )
            }
            {
              (cell.row.original.stampApplicationStatus === 0) && (
                <ContextMenu
                  text="申請中"
                  action={3}
                  buttons={
                    getContextMenuButtons(
                      history,
                      cell.row.original.modifierApplicationId,
                      cell.row.original.orgCode,
                      cell.row.original.staffCode,
                      cell.row.original.staffName,
                      null,
                      cell.row.original.holidayApplicationStatus,
                      cell.row.original.overtimeApplicationStatus,
                      cell.row.original.holidayworkApplicationStatus,
                      null,
                      "",
                      cell.row.original.useOverTimeApplication,
                      cell.row.original.necessaryHolidayWorkApplication,
                      cell.row.original.useTransferApplication,
                      cell.row.original.achievementId,
                      cell.row.original.targetDate,
                      cell.row.original.stampVersion,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      cell.row.original.stampApplicationStatus,
                      cell.row.original.hasError,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      cell.row.index
                    )
                  }
                />
              )
            }
          </div>
        ),
      },
      {
        Header: '日付',
        accessor: 'targetDate',
        isSorted: true,
        Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
          <div>
            {moment(cell.row.original.targetDate).format('MM/DD(ddd)')}
          </div>
        )
      },
      {
        Header: '組織',
        accessor: 'orgName',
        isSorted: true
      },
      {
        Header: 'スタッフ名',
        accessor: 'staffName',
        isSorted: true
      },
      {
        Header: '勤務予定',
        accessor: 'shiftTime'
      },
      {
        Header: '休暇',
        accessor: 'holidayWorkFlg',
        Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
          <div style={{ textAlign: 'center' }}>
            {/* {cell.row.original.holidayWorkFlg ? cell.row.original.holiday || '' : '休日出勤'} */}
            {
              cell.row.original.holidayWorkFlg && (
                <span style={{
                  background: cell.row.original.holidayBgColor,
                  borderRadius: '3px',
                  padding: '2px 7px',
                  color: cell.row.original.holidayForeColor,
                }}>休日出勤</span>
              )
            }
            {
              !cell.row.original.holidayWorkFlg && cell.row.original.holiday && (
                <span style={{
                  background: cell.row.original.holidayBgColor,
                  borderRadius: '3px',
                  padding: '2px 7px',
                  color: cell.row.original.holidayForeColor,
                }}>{cell.row.original.holiday}</span>
              )
            }
          </div>
        )
      },
      {
        Header: '出勤',
        accessor: 'startTime',
        Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
          <div style={{
            textAlign: 'center',
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex'
            , ...getStampTimeStyle(
              cell.row.original.errorHolidayWorkApplication || cell.row.original.errorDuplicate || cell.row.original.errorSametimeStamp
              , cell.row.original.alertContinuousWork || cell.row.original.alertUnder18MidnightWork || cell.row.original.alertForeignerOver28Hours || cell.row.original.alertForeignerValidityPeriod
              , cell.row.original.stampApplicationStatus
              , !!cell.row.original.startTime)
          }}>
            {
              cell.row.original.startTime
            }
          </div>
        )
      },
      {
        Header: '退勤',
        accessor: 'endTime',
        Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
          <div style={{
            textAlign: 'center',
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex'
            , ...getStampTimeStyle(
              cell.row.original.errorHolidayWorkApplication || cell.row.original.errorDuplicate || cell.row.original.errorSametimeStamp
              , cell.row.original.alertContinuousWork || cell.row.original.alertUnder18MidnightWork || cell.row.original.alertForeignerOver28Hours || cell.row.original.alertForeignerValidityPeriod
              , cell.row.original.stampApplicationStatus
              , !!cell.row.original.endTime)
          }}>
            {
              cell.row.original.endTime
            }
          </div>
        )
      },
      {
        Header: '休憩',
        accessor: 'recess',
        Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
          <div>
            {
              cell.row.original.recess.map((recess: any) => (
                `${recess.startTime} - ${recess.endTime || ''}\n`
              ))
            }
          </div>
        )
      },
      {
        Header: '未承認\n残業',
        accessor: 'allWorkTime'
      },
      {
        Header: '残業',
        accessor: 'unapprovedOverTime'
      },
      // {
      //   Header: 'エラー内容',
      //   accessor: 'errorMessage',
      //   Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
      //     <div>
      //       {cell.row.original.errorMessage.replace(/<\/br>/gi, '\n')}
      //     </div>
      //   )
      // }
    ],

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <BlockUI blocking={isLoading}>
      <FormHeader title="勤怠エラー実績" customStyle={css({ marginTop:'0'})} />
      <FormContents customStyle={css({marginTop:'60px'})}>
        <FormPadding customStyle={css({marginTop:'8px'})}>
          <Col md={12} xs={12}>
            <FlexBox customStyle={css({ flexWrap: 'wrap' })}>
              <FlexBoxItem width="100px">
                <FormLabel
                  label="期間"
                />
              </FlexBoxItem>
              <FlexBoxItem>
                <CalendarRangeV2 
                startDate={targetDateFrom}
                onChangeStart={(date: Date) => {
                  setTargetDateFrom(date);
                  sessionStorage.setItem('attendError.targetDateFrom', moment(date).format('YYYY-MM-DD'));
                }}
                endDate={targetDateTo}
                onChangeEnd={(date) => {
                  if(date){
                    setTargetDateTo(date);
                    sessionStorage.setItem('attendError.targetDateTo', moment(date).format('YYYY-MM-DD'));
                  }
                }}
                />
              </FlexBoxItem>
              {/* <FlexBoxItem width="200px">
                <CalendarForm label="" date={targetDateFrom}
                  required={true}
                  dateFormat='YYYY/MM/DD'
                  changeDate={(date: Date) => {
                    setTargetDateFrom(date);
                    sessionStorage.setItem('attendError.targetDateFrom', moment(date).format('YYYY-MM-DD'));
                  }} /> */}
                {/* <DatePicker
                    dateFormat="yyyy/MM/dd"
                    date={targetDateFrom}
                    changeDate={(date: Date) => {
                      setTargetDateFrom(date);
                      sessionStorage.setItem('attendError.targetDateFrom', moment(date).format('YYYY-MM-DD'));
                    }}
                    isFullWidth={false}
                  /> */}
              {/* </FlexBoxItem>

              <FlexBoxItem>
                <span style={{ margin: '0 20px' }}>～</span>
              </FlexBoxItem>

              <FlexBoxItem width="200px">
                <CalendarForm label="" date={targetDateTo}
                  required={true}
                  dateFormat='YYYY/MM/DD'
                  changeDate={(date: Date) => {
                    setTargetDateTo(date);
                    sessionStorage.setItem('attendError.targetDateTo', moment(date).format('YYYY-MM-DD'));
                  }} /> */}
                {/* <DatePicker
                    dateFormat="yyyy/MM/dd"
                    date={targetDateTo}
                    changeDate={(date: Date) => {
                      setTargetDateTo(date);
                      sessionStorage.setItem('attendError.targetDateTo', moment(date).format('YYYY-MM-DD'));
                    }}
                    isFullWidth={false}
                  /> */}
              {/* </FlexBoxItem> */}
            </FlexBox>
          </Col>
        </FormPadding>
        <FormPadding >
          <Row>
            <Col xl={6} md={12} xs={12} >
              <FlexBox>
                <FlexBoxItem width="100px">
                  <FormLabel
                    label="組織"
                  />
                </FlexBoxItem>

                <FlexBoxItem grow={1} width="150px">
                  <SelectForm
                    label=""
                    name="orgCode"
                    value={orgCode}
                    setValue={(val: string) => {
                      setOrgCode(val);
                    }}
                    options={storeOptions}
                    required={false}
                    ghost={(['3', '2'].indexOf(sessionStorage.getItem('loginUser.site') || "") === -1 && storeOptions.length === 1)}
                  />
                </FlexBoxItem>
              </FlexBox>
            </Col>
          </Row>
        </FormPadding>

        {/* staff filter */}
        <FormPadding>
          <Row>
            <Col xl={6} md={12} xs={12} >
              <FlexBox>
                <FlexBoxItem width="100px">
                  <FormLabel
                    label="スタッフ"
                  />
                </FlexBoxItem>

                <FlexBoxItem grow={1} width="150px">
                  <SelectForm
                    label=""
                    name="staffCode"
                    value={staffCode}
                    setValue={(v) => {
                      setStaffCode(v);
                    }}
                    options={staffsForOrgCodeOptions}
                    ghost={ [2,3].includes(Number(site)) ? false : true }
                    placeholder="スタッフを選択してください"
                  />
                </FlexBoxItem>
              </FlexBox>
            </Col>
          </Row>
        </FormPadding>

        <FormPadding>
          <Row>
            <Col lg={4} md={8} style={styles.radio}>
            <FlexBox customStyle={css({ flexWrap: 'wrap' })}>
            <FlexBoxItem width="100px">
                  <FormLabel
                    customStyle={css({ margin: '5px 0 0 0' })}
                    label="対象実績"
                  />
                </FlexBoxItem>
                <FlexBoxItem grow={1}>
                  <Radio
                    id="error"
                    name="error"
                    label="エラー"
                    value="error"
                    checked={isFilter}
                    onChange={() => {
                      sessionStorage.setItem('attendError.isFilter', String(!isFilter));
                      setIsFilter(!isFilter);
                    }}
                  />
                </FlexBoxItem>
                <FlexBoxItem grow={1}>
                  <Radio
                    id="alert"
                    name="error"
                    label="アラート"
                    value="alert"
                    checked={!isFilter}
                    onChange={() => {
                      sessionStorage.setItem('attendError.isFilter', String(!isFilter));
                      setIsFilter(!isFilter);
                    }}
                  />
                </FlexBoxItem>
            </FlexBox>
            </Col>
            <Col lg={8} md={12} style={styles.checkbox}>
              <FlexBox customStyle={css({ flexWrap: 'wrap' })}>
                <BodyText> ( </BodyText>
                <FlexBoxItem grow={1} textAlign='center'>
                  <Checkbox
                    id="showOT"
                    name="showError"
                    label="残業"
                    value="OT"
                    checked={isOT}
                    disabled={isFilter}
                    onChange={() => {
                      sessionStorage.setItem('dataError.OT', String(!isOT));
                      setOT(!isOT);
                    }}
                  />
                </FlexBoxItem>
                <FlexBoxItem grow={1} textAlign='center'>
                  <Checkbox
                    id="showErrorHolidayWork"
                    name="showHolidayWork"
                    label="休日出勤"
                    value="HolidayWork"
                    disabled={isFilter}
                    checked={isHolidayWork}
                    onChange={() => {
                      sessionStorage.setItem('dataError.HolidayWork', String(!isHolidayWork));
                      setHolidayWork(!isHolidayWork);
                    }}
                  />
                </FlexBoxItem>
                <FlexBoxItem grow={1} textAlign='center'>
                  <Checkbox
                    id="showErrorBreak"
                    name="showBreak"
                    label="休憩"
                    value="Break"
                    disabled={isFilter}
                    checked={isBreak}
                    onChange={() => {
                      sessionStorage.setItem('dataError.Break', String(!isBreak));
                      setBreak(!isBreak);
                    }}
                  />
                </FlexBoxItem>
                <FlexBoxItem grow={1} textAlign='center'>
                  <Checkbox
                    id="showErrorWorkingTogether"
                    name="showWorkingTogether"
                    label="連勤"
                    disabled={isFilter}
                    value="WorkingTogether"
                    checked={isWorkingTogether}
                    onChange={() => {
                      sessionStorage.setItem('dataError.WorkingTogether', String(!isWorkingTogether));
                      setWorkingTogether(!isWorkingTogether);
                    }}
                  />
                </FlexBoxItem>
                <FlexBoxItem grow={1} textAlign='center'>
                  <Checkbox
                    id="showErrorUnder18"
                    name="showUnder18"
                    label="18歳未満"
                    disabled={isFilter}
                    value="Under18"
                    checked={isUnder18}
                    onChange={() => {
                      sessionStorage.setItem('dataError.Under18', String(!isUnder18));
                      setUnder18(!isUnder18);
                    }}
                  />
                </FlexBoxItem>
                <FlexBoxItem grow={1} textAlign='center'>
                  <Checkbox
                    id="showErrorForeigner"
                    name="showForeigner"
                    label="外国人"
                    disabled={isFilter}
                    value="Foreigner"
                    checked={isForeigner}
                    onChange={() => {
                      sessionStorage.setItem('dataError.Foreigner', String(!isForeigner));
                      setForeigner(!isForeigner);
                    }}
                  />
                </FlexBoxItem>
                <BodyText> ) </BodyText>
              </FlexBox>
            </Col>
          </Row>
        </FormPadding>       

        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '15px' }}>
          <div css={styles.table}>
            <FlexBox customStyle={css({ display: 'flex', justifyContent: 'flex-end', marginRight: '28px' })}>
              <FlexBoxItem>
                <IconLabelButton
                  onClick={() => { isFilter ? downloadFileErrorCSV() : downloadFileAlertCSV() }}
                  iconType="download"
                  text="CSVダウンロード"
                />
              </FlexBoxItem>
            </FlexBox> 
            <div className="table-bordered table-padding ">
              <DataTable
                iconSize="16px"
                className='table-no-border-left-right'
                columns={columns} 
                data={errorList}
                isGlobalFilter={true}
                prefix={refixTable}
                highlightStatus={true}
                highlightAction={sessionStorage.getItem('highlightAction') || ''}
                highlightIndex={sessionStorage.getItem('highlightIndex') || ''}
                sortBy={[{ id: 'targetDate', desc: true }, { id: 'orgName', desc: true }, { id: 'staffName', desc: true }]}
                classNameParrant="border-left-right"
                // minWidth="1620px"
              />   
            </div>      
          </div>
        </div>
      </FormContents>
    </BlockUI>
  );
};

export default AttendanceError;
